import testsigmaCloudLogo from '@images/testsigma-cloud-logo.svg';

export const OnboardingHeader: React.FC = ({}) => {
  return (
    <div className='px-10 py-5'>
      <img src={testsigmaCloudLogo} />
    </div>
  );
};
